module.exports = __webpack_public_path__ + "static/media/1023489.a8cfc327.png";